import "./App.css";
import { RouterApp } from "./router";
import { BrowserRouter } from "react-router-dom";
import { YMInitializer } from "react-yandex-metrika";

function App() {
  return (
    <BrowserRouter>
      <YMInitializer accounts={[105572182]} options={{ webvisor: true }} />
      <RouterApp />
    </BrowserRouter>
  );
}

export default App;
